import React from 'react';
import moment from 'moment';

const CURRENT_STEP = 'CONFIRM';

export default function Confirm(props) {

  if (props.currentStep !== CURRENT_STEP) {
    return null;
  }

  const {
    groups,
    vaccine,
    startTime,
    endTime,
    location,
    provider,
    firstAppt,
    secondAppt,
    adverseDate,
    adverseProvider,
    adverseLocation,
    totalToSchedule,
    firstQuestionnaire,
    secondQuestionnaire,
    adverseQuestionnaire,
  } = props.data

  return <div className="card axs-shadow">
    <div className="card-body">
      <h3>Mass Schedule <small>Confirm</small></h3>

      <hr />

      <div className="row lead" style={{ fontSize: "medium" }}>
        <div className="col-12">
          <div className="alert alert-primary" role="alert">
            Confirm Mass Schedule Details
          </div>

          <div className="p-3">
            <div className="row">
              <div className="col-3">
                <p><strong>Start Time:</strong>&nbsp;{moment(startTime).format('L LT')}</p>
              </div>
              <div className="col-3">
                <p><strong>End Time:</strong>&nbsp;{moment(endTime).format('L LT')}</p>
              </div>
              <div className="col-3">
                <p><strong>Total To Schedule:</strong>&nbsp;{totalToSchedule}</p>
              </div>
            </div>

            <div className="row">
              <div className="col-3">
                <p className="text-capitalize"><strong>Vaccine:</strong>&nbsp;{vaccine}</p>
              </div>
              <div className="col-3">
                <p><strong>Location:</strong>&nbsp;{location.label}</p>
              </div>
              <div className="col-3">
                <p><strong>Provider:</strong>&nbsp;{provider.label}</p>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-3">
                <p><strong>First Dose:</strong>&nbsp;</p>
                <p><strong>Appointment Date:</strong>&nbsp;{moment(firstAppt).format("L LT")}</p>
              </div>
              <div className={vaccine === "janssen" ? "col-9" : "col-3"}>
                <p><strong>&nbsp;</strong>&nbsp;</p>
                <p><strong>Questionnaire:</strong>&nbsp;{firstQuestionnaire.label}</p>
              </div>
              <div className={vaccine === "janssen" ? "d-none" : "col-3"}>
                <p><strong>Second Dose:</strong>&nbsp;</p>
                <p><strong>Appointment Date:</strong>&nbsp;{moment(secondAppt).format("L LT")}</p>
              </div>
              <div className={vaccine === "janssen" ? "d-none" : "col-3"}>
                <p><strong>&nbsp;</strong>&nbsp;</p>
                <p><strong>Questionnaire:</strong>&nbsp;{secondQuestionnaire.label}</p>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-3">
                <p><strong>Adverse:</strong>&nbsp;</p>
                <p><strong>Complete By:</strong>&nbsp;{moment(adverseDate).format("L LT")}</p>
              </div>
              <div className="col-3">
                <p><strong>&nbsp;</strong>&nbsp;</p>
                <p><strong>Questionnaire:</strong>&nbsp;{adverseQuestionnaire.label}</p>
              </div>
              <div className="col-3">
                <p><strong>&nbsp;</strong>&nbsp;</p>
                <p><strong>Location:</strong>&nbsp;{adverseLocation.label}</p>
              </div>
              <div className="col-3">
                <p><strong>&nbsp;</strong>&nbsp;</p>
                <p><strong>Provider:</strong>&nbsp;{adverseProvider.label}</p>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col">
                <p><strong>Groups:</strong></p>
              </div>
              <div className="col">
                <p><strong>To Schedule:</strong></p>
              </div>
            </div>

            {groups.map((group, groupIndex) => {
              return <div className="row" key={groupIndex}>
                <div className="col">
                  <p key={`group_${groupIndex}`}>{group.name}</p>
                </div>
                <div className="col">
                  <p key={`count_${groupIndex}`}>{group.count}</p>
                </div>
              </div>
            })}
          </div>
        </div>
      </div>
    </div>
    <div className="card-footer">
      <div className="row">
        <div className="col-sm-4 pr-2">
          <button
            onClick={props.backStep}
            type="button" className="btn btn-outline-primary btn-block">Back</button>
        </div>
        <div className="col-sm-4 pl-2">
          <button onClick={props.handleCreateSchedule} disabled={props.loading} className="btn btn-block btn-success">
            {props.loading ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Create Mass Schedule'}
          </button>
        </div>
      </div>
    </div>
  </div >
}

